import React, { Component } from 'react';

class BaseComponent extends Component {
  render() {
    return (
      <div>Component Example</div>
    )
  }
}

export default BaseComponent;


// WEBPACK FOOTER //
// ./src/script/components/common/BaseComponent.js